export default "__VITE_ASSET__BAzt49df__"